// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"323":"835224dfe1425736","463":"315792c8fcc039dd"}[chunkId] + ".js";
};